module.exports = __webpack_public_path__ + "img/Visa_Electron.aa35e402.svg";